import React, { useEffect, useRef, useState } from "react";
import API from "@/lib/api";
import { ADS_MODE, ADSENSE_CLIENT_ID, ADSENSE_SLOTS } from "@/config/ads";
import { adsAllowed, loadAdsense, onConsentChange } from "@/lib/consent";

const HEIGHTS = { home: "h-[120px] sm:h-[110px]", list: "h-[140px]", detail: "h-[260px] sm:h-[200px]" };

function SponsorBanner({ placement, category }) {
  const [ad, setAd] = useState(undefined);
  useEffect(() => {
    API.get("/public/ad", { params: { placement, category } }).then((r) => setAd(r.data)).catch(() => setAd(null));
  }, [placement, category]);
  if (!ad) return <div className="w-full h-full rounded-[18px] bg-[#E4E8F1]" />;
  return (
    <a href={ad.link_url} target="_blank" rel="sponsored noopener noreferrer" data-testid={`ad-sponsor-${placement}`}
      className="flex w-full h-full rounded-[18px] overflow-hidden bg-white shadow-[0_4px_18px_-6px_rgba(15,18,48,0.18)]">
      <img src={ad.image_url} alt={ad.name} loading="lazy" className="h-full w-2/5 sm:w-1/3 object-cover" />
      <span className="flex-1 p-4 flex flex-col justify-center min-w-0">
        <span className="text-base font-extrabold text-[#0F1230] truncate">{ad.name}</span>
        <span className="text-sm font-bold text-[#1F4FE0]">Scopri di più →</span>
      </span>
    </a>
  );
}

function AdsenseUnit({ placement }) {
  const [ok, setOk] = useState(adsAllowed());
  const pushed = useRef(false);
  useEffect(() => onConsentChange(() => setOk(adsAllowed())), []);
  useEffect(() => {
    if (!ok || pushed.current) return;
    loadAdsense();
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); pushed.current = true; } catch {}
  }, [ok]);
  if (!ok) return <div className="w-full h-full rounded-[18px] bg-[#E4E8F1]" />;
  return (
    <ins className="adsbygoogle block w-full h-full" data-ad-client={ADSENSE_CLIENT_ID}
      data-ad-slot={ADSENSE_SLOTS[placement]} data-ad-format="auto" data-full-width-responsive="true" />
  );
}

export function AdSlot({ placement, category, className = "" }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (ADS_MODE === "off" || !ref.current) return;
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setVisible(true); io.disconnect(); } }, { rootMargin: "200px" });
    io.observe(ref.current);
    return () => io.disconnect();
  }, []);
  if (ADS_MODE === "off") return null;
  return (
    <div ref={ref} data-testid={`ad-slot-${placement}`} className={`w-full ${className}`}>
      <p className="text-[10px] font-bold uppercase tracking-wider text-[#4A4E68] mb-1">Pubblicità</p>
      <div className={`w-full ${HEIGHTS[placement] || "h-[120px]"}`}>
        {visible && (ADS_MODE === "sponsor" ? <SponsorBanner placement={placement} category={category} /> : <AdsenseUnit placement={placement} />)}
      </div>
    </div>
  );
}
